var map = {
	"./01.jpg": 83820,
	"./02.jpg": 44443,
	"./03.jpg": 59486,
	"./04.jpg": 6821,
	"./05.jpg": 62856,
	"./06.jpg": 73783,
	"./07.jpg": 2618,
	"./08.jpg": 79969,
	"./09.jpg": 1924,
	"./10.jpg": 22610,
	"./11.jpg": 78639,
	"./12.jpg": 81376
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 810;